import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Modal, ModalBody, ModalFooter, ModalHeader, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import * as ARInvoiceStore from '../../store/ARInvoice';
import * as ARInvoiceMdls from '../../models/ArInvoiceModel';
import * as SessionMdl from '../../models/SessionModel';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';
import {  faCommentDots } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


type MyProps =
    { ARInvoiceList: ARInvoiceMdls.ArInvoiceModelList, SessionState: SessionMdl.SessionModel } & typeof ARInvoiceStore.actionCreators;

const PaidInvoices: React.FunctionComponent<MyProps> = (props: MyProps) => {

    useEffect(() => {
        props.loadInvoices(true); //Only paid invoices
    }, []);


    const showComments = (item: ARInvoiceMdls.ArInvoiceModel) => {
        updateComment(item.invoiceComments != null ? item.invoiceComments : '');
        updateTitle(item.invoiceNumber);
        toggle();
    }

    const [commentToDisplay, updateComment] = useState('');
    const [titleToDisplay, updateTitle] = useState('');

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    return (
        <>
        <Container fluid={true}>
                <LoadingIcon loading={props.ARInvoiceList.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            <Card style={{ marginTop:"10px" }}>                
                <div>
                    <Table>
                        <thead>
                            <tr>
                                <th style={{width:"32%"}}>Invoice</th>
                                <th style={{ width: "32%" }}>Date</th>
                                <th style={{ width: "32%", textAlign:'right' }}>Invoice Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.ARInvoiceList.items.map((item, index) =>
                                <tr key={index}>
                                    <td colSpan={3} style={{ padding: "0px", margin: "0px" }}>
                                        <Table style={{ padding: 0, margin: 0, backgroundColor: "rgba(236, 238, 244, .4)" }}>
                                            <tbody>
                                            <tr>
                                                    <th style={{ width: "32%" }}>
                                                        {item.invoiceNumber}
                                                        {item.invoiceComments &&
                                                            <FontAwesomeIcon style={{ cursor: "pointer" }} onClick={() => showComments(item)} icon={faCommentDots} className="commentsBtn" />
                                                        }
                                                    </th>
                                                <td style={{ width: "32%" }}><SaDate Value={item.invoiceDate} /></td>
                                                <td style={{ width: "32%", textAlign:'right' }}><SaCurrency Amount={item.total} /></td>
                                                </tr>
                                            </tbody>
                                            </Table>
                                        <Table style={{ padding: "0,10,0,0", margin: "0,10,0,0" }}>                                                                                    
                                            {/*{item.invoicePayments.length>0 &&*/}
                                            {/*    <thead>*/}
                                            {/*        <tr key={`head-${index}`}>*/}
                                            {/*        <th style={{ width: "6%" }}></th>*/}
                                            {/*        <th colSpan={3} style={{ width: "90%", textAlign:"center", backgroundColor: "rgba(255, 250, 210, 1)" }}>Payments</th>                                                                                                            */}
                                            {/*        </tr>*/}
                                            {/*    </thead>*/}
                                            {/*}*/}

                                                    
                                                        <tbody>
                                                {item.invoicePayments && item.invoicePayments.map((pay, payIndex) =>
                                                    <tr key={payIndex}>
                                                        <td style={{ width: "6%", backgroundColor: "rgba(255, 250, 210, 1)", borderBottom:"solid lightgray 1px" }}></td>
                                                        <td style={{ width: "25%", backgroundColor: "rgba(255, 250, 210, 1)", borderBottom: "solid lightgray 1px" }}>
                                                            {payIndex == 0 && <SaLabel Text="Date" />}  <SaDate Value={pay.paymentDate} />
                                                    </td>
                                                        <td style={{ width: "35%", backgroundColor: "rgba(255, 250, 210, 1)", borderBottom: "solid lightgray 1px" }}>
                                                            {payIndex == 0 && <SaLabel Text="Reference" />} {pay.paymentRef}
                                                    </td>
                                                        <td style={{ width: "30%", textAlign: "right", backgroundColor: "rgba(255, 250, 210, 1)", borderBottom: "solid lightgray 1px" }}>
                                                            {payIndex == 0 && <SaLabel Text="Amount paid" />} <SaCurrency Amount={pay.paymentAmount} />
                                                    </td>
                                                </tr>
                                                )}
                                                </tbody>
                                        </Table>
                                    </td>
                                </tr>                                
                            )}
                        </tbody>
                    </Table>
                </div>
            </Card>
            </Container>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>{titleToDisplay}</ModalHeader>
                <ModalBody>
                    {commentToDisplay}
                </ModalBody>
                <ModalFooter>                    
                    <Button color="secondary" onClick={toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        </>

    );
}

export default connect((state: ApplicationState) =>
    ({ ...{ ARInvoiceList: state.openInvoicesState, SessionState: state.sessionState } }),
    ARInvoiceStore.actionCreators)(PaidInvoices as any);